import React, {useEffect, useState} from 'react';
import axios from '../axios';
import {Link} from 'react-router-dom';
import {
    Container,
    CreateBtn,
    DetailsBtns,
    DetailsHeading, Flex,
    H1,
    ListHeading, SmallSpacing,
    Table,
    Td,
    Th,
    Tr
} from "../../styles";
import useAdminStatus from "../hooks/useAdminStatus";

const Classes = () => {
    const [classes, setClasses] = useState([]);
    const {isAdmin} = useAdminStatus();

    useEffect(() => {
        axios.get('/classes/')
            .then((response) => {
                console.log("Classes data:", response.data); // Log response data
                setClasses(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this class?")) {
            axios.delete(`/class/delete/${id}/`)
                .then(() => {
                    setClasses(classes.filter(classItem => classItem.id !== id));
                })
                .catch(error => {
                    console.error("There was an error deleting the class!", error);
                });
        }
    };
    if (!classes) {
        return <div>Loading...</div>;
    }
    return (
        <Container>
            <ListHeading>
                <H1>Classes list</H1>
                {isAdmin && (
                    <Link to="/class/create">
                        <CreateBtn>
                            Add Class
                        </CreateBtn>
                    </Link>
                )}

            </ListHeading>
            <Table>
                <Tr>
                    <Th>Class Name</Th>
                    <Th>Class Number</Th>
                    <Th>Semester</Th>
                    <DetailsHeading>Details</DetailsHeading>
                </Tr>
                {classes.map((classItem) => (
                    <Tr key={classItem.id}>
                        <Td>{classItem.course_details?.name || "N/A"}</Td>
                        <Td>{classItem.number}</Td>
                        <Td>
                            {classItem.semester_details ?
                                `Semester ${classItem.semester_details.semester} - ${classItem.semester_details.year}`
                                : "N/A"}
                        </Td>
                        <DetailsBtns>
                            <Flex>
                                <Link to={`/class/${classItem.id}`}>View</Link>
                                <SmallSpacing/>
                                {isAdmin && (
                                    <>
                                        <Link to={`/class/update/${classItem.id}`}>Update</Link>
                                        <SmallSpacing/>
                                        <Link to="#" onClick={() => handleDelete(classItem.id)}>Delete</Link>

                                    </>
                                )}
                            </Flex>
                        </DetailsBtns>
                    </Tr>
                ))}
            </Table>
        </Container>
    );
};

export default Classes;
